import React from 'react'
import Button from '@mui/material/Button'
import Text from '../Text'
import type { ButtonProps } from '@mui/material/Button'
import type { TextProps } from '../Text'

type FilledButtonProps = {
  children: React.ReactNode
  onClick: () => void
  startIcon?: React.ReactNode
  color?: 'primary' | 'error'
  textProps?: Omit<TextProps, 'children'>
  buttonProps?: Omit<ButtonProps, 'sx'>
  sx?: ButtonProps['sx']
  disabled?: boolean
}

function FilledButton({
  children,
  onClick,
  startIcon,
  color = 'primary',
  textProps = {},
  buttonProps = {},
  sx = {},
  disabled =false
}: FilledButtonProps) {
  return (
    <Button
      variant='contained'
      color={color}
      startIcon={startIcon || null}
      size='large'
      disabled={disabled}
      sx={{
        margin: 2,
        borderRadius: '6px',
        '& .MuiButton-startIcon': { margin: 0, padding: 0 },
        '& .MuiTypography-root': { margin: 0, padding: 0 },
        ...sx,
      }}
      onClick={onClick}
      {...buttonProps}
    >
      <Text {...textProps}>{children}</Text>
    </Button>
  )
}

export default FilledButton
